WhatsRunningApp.Views.PostProcess = Backbone.View.extend({
    className: "col-lg-12",

    initialize: function() {
        var self = this;

        this.timer = function () {
            self.model.set({feeds : ['initial state']})
            self.model.fetch()
        }

        $('.post-process').append(this.$el);

        $.ajax({
			url: '/assets/js/admin/whats-running/03_templates/post-process.html',
			success: function(extTemplate) {
                self.template = _.template(extTemplate);
                self.render();
                self.model.fetch();
			},
			cache: false
        });

        setInterval(this.timer.bind(this), 15000);
        this.model.on('change', this.render, this);
    },

    render: function() {
        var model = this.model.toJSON();
        this.$el.html(this.template(model));

        if (model.postprocess.length != 1 || model.postprocess[0] != 'initial state') {
            $('.post-process').toggleClass('sk-loading');
        }
    },

    close: function() {
        clearInterval(this.timer);
        this.remove();
        this.unbind();
    }
});